"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Rectangle_1 = __importDefault(require("../../../loaders/Rectangle/Rectangle"));
require("./credentialMainInfoCardLoader.scss");
function CredentialMainInfoCardLoader(props) {
    return props.isMobile ? (react_1.default.createElement("div", { id: "credential-main-info-card-loader-mobile", className: "flex-column" },
        react_1.default.createElement("div", { className: "org-cont" },
            react_1.default.createElement("div", { className: "org-img-info" },
                react_1.default.createElement(Rectangle_1.default, { width: 100, radius: 0, height: 100 }),
                react_1.default.createElement("div", { className: "flex-column jc-sb  ai-fs" },
                    react_1.default.createElement(Rectangle_1.default, { width: 200, radius: 0, height: 20 }),
                    react_1.default.createElement(Rectangle_1.default, { width: 200, radius: 0, height: 20 }))),
            react_1.default.createElement("div", { className: "org-action-container" },
                react_1.default.createElement(Rectangle_1.default, { width: 45, radius: 0, height: 29 }))))) : (react_1.default.createElement("div", { id: "credential-main-info-card-loader-web", className: "flex-column" },
        react_1.default.createElement("div", { className: "org-cont" },
            react_1.default.createElement("div", { className: "org-img-info" },
                react_1.default.createElement(Rectangle_1.default, { width: 100, radius: 0, height: 100 }),
                react_1.default.createElement("div", { className: "flex-column jc-sb  ai-fs" },
                    react_1.default.createElement(Rectangle_1.default, { width: 200, radius: 0, height: 20 }),
                    react_1.default.createElement(Rectangle_1.default, { width: 200, radius: 0, height: 20 }))),
            react_1.default.createElement("div", { className: "org-action-container" },
                react_1.default.createElement(Rectangle_1.default, { width: 45, radius: 0, height: 29 })))));
}
exports.default = CredentialMainInfoCardLoader;
